module.exports = __webpack_public_path__ + "img/120-bahamas.9de94cbc.svg";